import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, addDoc, setDoc, updateDoc, doc, getDoc, where, query } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

export const googleClientId = "648181233135-scm8o3v0r9d28vpbrapsthftaouplsv2.apps.googleusercontent.com";

export const firebaseConfig = {
    apiKey: "AIzaSyDl8f6EYFDkCdwA4E5HYv8NvwLxCq1TZtQ",
    authDomain: "crafttatva-com.firebaseapp.com",
    projectId: "crafttatva-com",
    storageBucket: "crafttatva-com.appspot.com",
    messagingSenderId: "648181233135",
    appId: "1:648181233135:web:76703ef5038f5d373d721a",
    measurementId: "G-W584HC0342"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Export the db instance
export {
    db,
    collection,
    getDocs, addDoc, setDoc, updateDoc, doc, getDoc, where, query,
    auth,
    storage,
};

// Export the app instance
export default app;